import styled from "@emotion/styled";

export const Time = styled.span`
  all: unset;
  font-family: var(--ha-font-family);
  font-size: 2rem;
  color: var(--ha-S200-contrast);
  font-weight: 400;
  display: flex;
  flex-direction: row;
`;

export const AmOrPm = styled.span`
  all: unset;
  font-family: var(--ha-font-family);
  font-size: 2rem;
  color: var(--ha-S400-contrast);
  font-weight: 300;
`;
